
/*
* @Author: syyoon@yongtrim.com 
* @Date: 2018-10-16 19:36:57 
 * @Last Modified by: syyoon@yongtrim.com
 * @Last Modified time: 2018-10-16 21:37:28
*/

import { Injectable } from "@angular/core";

import { LineLogin } from '@ionic-native/line-login';
import { PlatformService } from "../services/platform.service";
import { AlertService } from "../services/alert.service";


@Injectable()
export class LineService {

  isLoggedIn = false;

  snsId: string;
  email: string;
  name: string;
  photoUrl: string;

  constructor(
    private alertService: AlertService,
    private platformService: PlatformService,
    private lineLogin: LineLogin) {

  }

  init() {

    if (!this.platformService.isWeb()) {
      this.lineLogin.initialize({ channel_id: '1614682943' })
        .then(res => {
        });
    }
  }


  login(): any {
    if (this.platformService.isWeb()) {
      this.alertService.showToastMessage('웹에서는 사용하실 수 없습니다.');
      return Promise.reject({});
    }
    return this.lineLogin.login()
      .then(res => {
        this.isLoggedIn = true;
        this.snsId = res['userID'];
        this.name = res['displayName'];
        this.photoUrl = res['pictureURL'];
        this.email = '';
        return Promise.resolve({
          snsId: this.snsId,
          email: this.email,
          name: this.name,
          photoUrl: this.photoUrl,
        });
      })

  }

  logout(): any {
    if (!this.isLoggedIn)
      return Promise.resolve();
    return this.lineLogin.logout()
      .then(res => {
        this.isLoggedIn = false;
        return Promise.resolve();
      })
  }
}


// WEBPACK FOOTER //
// ./src/services-sns/line.service.ts